<template>
  <Page class="home" title="Заказы" compname="Orders"/>
</template>

<script>
export default {
  name: 'HomeView',
}
</script>
